/**
 * Gets input
 * @param {string} id
 * @returns {HTMLInputElement | HTMLSelectElement | void}
 */
export function getInputById(id) {
  const input = /** @type {HTMLInputElement | HTMLSelectElement | null} */ (
    document.getElementById(id)
  )
  if (input) {
    return input
  }
}
